import { type Procedure } from "@overmap-ai/common"
import { addProcedureStepEvents, ProcedureStepEventService as OvermapProcedureStepEventService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import { AppSDK, sdk } from "../sdk"

export class ProcedureStepEventService extends OvermapProcedureStepEventService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL

	async refreshForProcedure(procedureId: Procedure["uuid"], signal?: AbortSignal) {
		const result = await sdk.procedureStepEvents.list(
			{
				queryParams: {
					procedure: procedureId,
				},
			},
			signal,
		)

		this.dispatch(addProcedureStepEvents(result))

		return result
	}
}
